// Getters
export const articles = (state) => {
  return state.articles.data || []
}
export const articlesLoading = (state) => {
  return state.articles.loading
}
export const articlesLoadingFirst = (state) => {
  return state.articles.loading === 'first'
}
export const articlesLoadingMore = (state) => {
  return state.articles.loading === 'more'
}
export const articlesError = (state) => {
  return state.articles.error
}
export const nextCursor = (state) => {
  return state.articles.nextCursor
}
export const hasMore = (state) => {
  return state.articles.hasMore
}
export const lastUpdate = (state) => {
  return state.articles.lastUpdate
}
export const sources = (state) => {
  return state.sources || []
}
export const filtroSources = (state) => {
  return state.filtros.sources || []
}
export const filtroTermo = (state) => {
  return state.filtros.termo || ''
}
